var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Watch } from 'vue-property-decorator';
import Component from 'vue-class-component';
import TakeStockService from '../../../api/TakeStockService';
import HeaderItem from "../../../components/HeaderItem";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.supplierupperOptions = [];
        _this.accountOptions = [];
        _this.supplierorganOptions = [];
        _this.supplierdepotOptions = [];
        _this.docTypeList = [
            { name: '订单采购', value: 1 },
            { name: '自定义采购', value: 0 }
        ];
        _this.orderTypeOptions = [
            { name: '日盘', value: 1 },
            { name: '周盘', value: 2 },
            { name: '月盘', value: 3 }
        ];
        _this.orderModeOptions = [
            { name: '按盘点类型', value: 0 },
            { name: '按库存盘点', value: 1 },
            { name: '自定义', value: 2 }
        ];
        return _this;
    }
    default_1.prototype.watchFormDataOrganId = function (newVal, oldVal) {
        if (this.handleStatus == 1) {
            this.formData.depot_id = '';
            this.getSupplierdepotOptions();
        }
        if (newVal) {
            var obj = this.supplierorganOptions.find(function (item) {
                return item.organ_id === newVal;
            });
            this.$emit('changeImportTitle', 'organ_name', obj.organ_name);
        }
    };
    default_1.prototype.WatchFormDataDepotId = function (newVal, oldVal) {
        if (newVal) {
            var obj = this.supplierdepotOptions.find(function (item) {
                return item.depot_id === newVal;
            });
            this.$emit('changeImportTitle', 'depot_name', obj.depot_name);
        }
    };
    default_1.prototype.WatchFormDataOrderType = function (newVal, oldVal) {
        if (newVal) {
            var obj = this.orderTypeOptions.find(function (item) {
                return item.value === newVal;
            });
            this.$emit('changeImportTitle', 'order_type_name', obj.name);
        }
    };
    default_1.prototype.WatchFormDataOrderMode = function (newVal, oldVal) {
        var obj = this.orderModeOptions.find(function (item) {
            return item.value === newVal;
        });
        this.$emit('changeImportTitle', 'stock_type_name', obj.name);
    };
    default_1.prototype.created = function () {
        this.takeStockService = TakeStockService.getInstance();
        if (this.handleStatus == 1) {
            this.getSupplierupperOptions();
            this.getSupplierorganOptions();
        }
    };
    default_1.prototype.mounted = function () { };
    default_1.prototype.getSupplierupperOptions = function () {
        var _this = this;
        this.takeStockService.getSupplierupperOptions().then(function (res) {
            if (res.data.success) {
                _this.supplierupperOptions = res.data.data;
            }
        });
    };
    default_1.prototype.getSupplierorganOptions = function () {
        var _this = this;
        this.takeStockService.getSupplierorganOptions().then(function (res) {
            if (res.data.success) {
                _this.supplierorganOptions = res.data.data;
                _this.formData.organ_id = res.data.data && res.data.data[0].organ_id || '';
                _this.getSupplierdepotOptions();
                _this.getAccountOptions();
            }
        });
    };
    default_1.prototype.getSupplierdepotOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id,
            is_init: 1
        };
        this.takeStockService.getSupplierdepotOptions(params).then(function (res) {
            if (res.data.success) {
                _this.supplierdepotOptions = res.data.data;
                (res.data.data || []).some(function (item) {
                    if (item.is_organ_default == 1) {
                        _this.formData.depot_id = item.depot_id;
                        return true;
                    }
                    _this.formData.depot_id = '';
                });
            }
        });
    };
    default_1.prototype.getAccountOptions = function () {
        var _this = this;
        var params = {
            organ_id: this.formData.organ_id
        };
        this.takeStockService.getAccountOptions().then(function (res) {
            if (res.data.success) {
                _this.accountOptions = res.data.data;
            }
        });
    };
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "formData", void 0);
    __decorate([
        Prop({
            required: true
        })
    ], default_1.prototype, "ImportTitle", void 0);
    __decorate([
        Prop({
            required: true,
            type: Number
        })
    ], default_1.prototype, "handleStatus", void 0);
    __decorate([
        Watch('formData.organ_id')
    ], default_1.prototype, "watchFormDataOrganId", null);
    __decorate([
        Watch('formData.depot_id')
    ], default_1.prototype, "WatchFormDataDepotId", null);
    __decorate([
        Watch('formData.order_type')
    ], default_1.prototype, "WatchFormDataOrderType", null);
    __decorate([
        Watch('formData.order_mode')
    ], default_1.prototype, "WatchFormDataOrderMode", null);
    default_1 = __decorate([
        Component({
            components: {
                HeaderItem: HeaderItem
            }
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
